import React, { useState } from "react";
import Style from "./Warning.module.css";
import { useEditChannelAction } from "../../../hooks/useChannel";
import { GoBlocked } from "react-icons/go";
import { logOut } from "../../../services/authService";
import webSocket from "../../../services/onlineSocketService";
import { logoutUser } from "../../../utils/localStorageUtils";
import { useNavigate } from "react-router-dom";
import { deleteToken } from "firebase/messaging";
import { messaging } from "../../../firebase/firebase";

const AccountDeactive = ({ onClose, channelId, update = "" }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate();

  useEditChannelAction(channelId);
  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      const success = await deleteToken(messaging);
      if (success) {
        await logOut();
        webSocket.disconnect(); // Disconnect WebSocket
        logoutUser();
        window.location.reload();

        // Clear localStorage/session
        navigate("/login"); // Wait for logout API to complete
        onClose();
      }

      // Redirect // Wait for logout API to complete
    } catch (error) {
      console.error("Logout API failed", error);
      // Optional: Show error to user or continue
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className={Style.WarningdeleteConfirmation}>
      <div className={Style.WarningconfirmationCard}>
        <>
          <div className={Style.WarningiconContainer}>
            <GoBlocked size={50} color="red" />
          </div>

          <h3>Your account has been deactivated</h3>
          <p className={Style.Warrningpara}>
            {" "}
            You can no longer access your account. Please contact support if
            this is a mistake.
          </p>

          <div className={Style.WarningbuttonGroup}>
            <button
              className={`${Style.WarningdeleteBtn} ${
                isDeleting ? Style.Warningdeleting : ""
              }`}
              onClick={handleDelete}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <div className={Style.Warningspinner}></div>
              ) : (
                "Done"
              )}
            </button>
          </div>
        </>
      </div>
    </div>
  );
};

export default AccountDeactive;
